import { render, staticRenderFns } from "./Minus.vue?vue&type=template&id=6b22f4fe&scoped=true&"
import script from "./Minus.vue?vue&type=script&lang=js&"
export * from "./Minus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b22f4fe",
  null
  
)

export default component.exports